import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import Footer from "@/components/common/footers/footer/footer";
import useLocalStorage from "@/hooks/use-local-storage/useLocalStorage";
import ProphiaLogo from "@/assets/prophia/prophia_abstract_full_logo.png";
import styles from "./under-construction.module.scss";
import {
  formatInLocalTimeZone,
  formatHumanReadableTime,
} from "@/utils/date-utils/date-utils";
import { FULL_DATE_TIME } from "badlands-shared/constants";
import zonedTimeToUtc from "date-fns-tz/zonedTimeToUtc";
import { isValid } from "date-fns";
import { ThemeProvider } from "../theme/ThemeContext";
import { useConditionalFeatureFlagPayload } from "@/hooks/posthog/use-conditional-feature-flag-payload/useConditionalFeatureFlagPayload";

const FEATURE_FLAG_KEY = "under-construction";
const UNDER_CONSTRUCTION_KEY = "under-construction-bypass";

export const UnderConstruction = ({ children }) => {
  const payload = useConditionalFeatureFlagPayload(FEATURE_FLAG_KEY);
  const { t } = useTranslation();
  const [localStorageBypass, saveBypass] = useLocalStorage(
    UNDER_CONSTRUCTION_KEY,
    false
  );
  const searchParams = new URLSearchParams(window.location.search);
  const isBypassed =
    searchParams.has(UNDER_CONSTRUCTION_KEY) || localStorageBypass;
  const endTime = zonedTimeToUtc(payload?.endTime, payload?.timeZone);
  const formattedEndTime = isValid(endTime)
    ? formatInLocalTimeZone(endTime, FULL_DATE_TIME)
    : "";
  const timeRemaining = isValid(endTime)
    ? endTime.getTime() - new Date().getTime()
    : "";
  const formattedTimeRemaining = formatHumanReadableTime(timeRemaining);

  useEffect(() => {
    if (isBypassed) {
      saveBypass(true);
    }
  }, [saveBypass, isBypassed]);

  if (payload && !isBypassed) {
    return (
      <ThemeProvider>
        <div
          className={`${styles.underConstruction} flex column center align-center row-gap-4`}
        >
          <div className="flex column start grow align-center">
            <div
              className={`${styles.logoContainer} flex center align-center mt-4`}
            >
              <img
                src={ProphiaLogo}
                alt="Prophia Logo"
                className={styles.logo}
              />
            </div>
            <div className={`${styles.title} bold top mt-8`}>
              {t("plannedMaintenance")}
            </div>
            <div className={`${styles.icon} flex align-center center p-12`}>
              <FontAwesomeIcon icon="fa-solid fa-person-digging" />
            </div>
            <div className={`${styles.body} flex column row-gap-2 grow pt-12`}>
              <div className={""}>{t("checkBackSoon")}</div>
              <div className={`bold`}>
                {t("estimatedDowntime", {
                  timeRemaining: formattedTimeRemaining,
                  endTime: formattedEndTime,
                })}
              </div>
            </div>
            <Footer className={`${styles.footer}`} />
          </div>
        </div>
      </ThemeProvider>
    );
  }
  return <>{children}</>;
};

export default UnderConstruction;
